import Dexie from 'dexie';
import { useLiveQuery } from 'dexie-react-hooks';

import db, { DEXIE_IS_LOADING } from './db';
import { compareSortOrders } from '../feed/core/ids';

function latestTranscriptQuery(table, channelId) {
  return table
    .where('[channel_id+type+sort_order]')
    .between([channelId, 'conference_transcript', Dexie.minKey], [channelId, 'conference_transcript', Dexie.maxKey], false, true)
    .reverse()
    .first();
}

// Reads the durable feed cache first — any channel opened under the current feed persists
// its transcripts to feed_messages. The legacy table remains a deliberate cold-start
// fallback: /messages/bootstrap seeds only legacy `messages`, and background replication
// skips channels with no feed sync cursor, so a channel never opened under the current
// feed (e.g. status checks from Board/Search) may hold its transcript only in legacy.
// Whichever store has the newer transcript wins; the feed row wins ties.
//
// Ordering goes through the feed's compareSortOrders, not lib/stringUtils' sortULIDs.
// The two disagree on method (codepoint vs localeCompare) though not on outcome for
// well-formed ULIDs; a feed row's sort order is the feed comparator's to order.
export function useSingleChannelLatestConferenceTranscript(channelId) {
  return useLiveQuery(
    async () => {
      if (!channelId) return false;

      const [feedTranscript, legacyTranscript] = await Promise.all([
        latestTranscriptQuery(db.feed_messages, channelId),
        latestTranscriptQuery(db.messages, channelId),
      ]);

      if (!feedTranscript || !legacyTranscript) return feedTranscript || legacyTranscript;
      return compareSortOrders(String(legacyTranscript.sort_order), String(feedTranscript.sort_order)) > 0
        ? legacyTranscript
        : feedTranscript;
    },
    [channelId],
    DEXIE_IS_LOADING,
  );
}
